import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import Select from "react-select";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Button from "../../AdminModule/Dashboard/AdminDashboard/Button";
import swal from "sweetalert";
import { makeStyles } from "@material-ui/core/styles";
import FileUpload from "../FileUpload";
import "./styles.scss";
function AllSummayModal(props) {
  const { summaryData, sessionId, modalDataList, summaryFullModalData } = props;
  const [modalValue, setModalValues] = useState();
  let userRole = JSON.parse(localStorage.getItem("SavedLoggedInData"))?.role;

  const handleClose = () => {
    props.setModalVisibility(false);
  };
  useEffect(() => {
    if (summaryData !== undefined) {
      setModalValues(summaryData);

      // if(modalDataList === )
      // let obj = modalDataList.find(data => data.sessionId === sessionId);
      // if(obj !== undefined)
      // {
      //
      //   setModalValues(obj)
      // }
      // setsummaryFullModalDatas(summaryData?.startupSummary)
      // else
      // if(modalDataList === )
      // let obj = modalDataList.find(data => data.sessionId === sessionId);
      //
      // if(obj === undefined)
      // setsummaryFullModalDatas(summaryData?.data?.startupSummary)
      // else
      // setsummaryFullModalDatas(obj?.startupSummary)
    }
  }, [props]);
  return (
    <>
      <div className="modal-dialog modal-dialog-centered modalBoxPositionFix">
        <Modal
          size="lg"
          show={props.modalVisibility}
          onHide={() => props.setModalVisibility(false)}
          aria-labelledby="example-modal-sizes-title-lg"
          style={{ borderRadius: "7px" }}
          className="sessionnotes2ndnewanotheragainnew"
        >
          <Modal.Header className="d-flex">
            <Modal.Title className="modalHeading">SESSION NOTES</Modal.Title>
            <div className="newuserTooltip">
              <button
                type="button"
                className="btn-close "
                aria-label="Close"
                onClick={handleClose}
              />
              <span
                className="tooltiptext  close-window"
                style={{ left: "-130px", top: "2px", width: "130px" }}
              >
                Close Window
              </span>
            </div>
          </Modal.Header>
          <Modal.Body>
            <div className="session-detailsModal">
              <div className="col-md-10 col-12 tableBoxAlign tableAligningpurpose">
                <table id="session">
                  <tbody>
                    <>
                      {userRole !== "Mentor" && (
                        <tr className="col-12">
                          <td className="session-question  col-md-6 col-sm-6 col-11">
                            <p>SESSION RATING BY STARTUP (out of 5)</p>
                          </td>
                          <td className="session-answer col-md-6 col-sm-6 col-1">
                            <p>
                              {modalValue?.startupSummary === null
                                ? "NA"
                                : modalValue?.startupSummary?.sessionFeedback}
                            </p>
                          </td>
                        </tr>
                      )}
                      {userRole !== "Startup" && (
                        <tr className="col-12">
                          <td className="session-question col-md-6 col-sm-6 col-11">
                            <p>SESSION RATING BY MENTOR (out of 5)</p>
                          </td>
                          <td className="session-answer col-md-6 col-sm-6 col-1">
                            <p>
                              {modalValue?.mentorSummary === null
                                ? "NA"
                                : modalValue?.mentorSummary?.sessionFeedback}
                            </p>
                          </td>
                        </tr>
                      )}

                      <tr className="col-12">
                        <td className="session-question col-md-6 col-sm-6 col-11">
                          <p>SESSION DURATION (in hours)</p>
                        </td>
                        <td className="session-answer col-md-6 col-sm-6 col-1">
                          <p>
                            {modalValue?.startupSummary === null
                              ? "NA"
                              : modalValue?.startupSummary?.sessionHours}
                          </p>
                        </td>
                      </tr>

                      <tr className="col-12">
                        <td className="session-question col-md-6 col-sm-6 col-11">
                          <p>STARTUP SUMMARY</p>
                        </td>
                        <td className="session-answer col-md-6 col-sm-6 col-1">
                          {modalValue?.startupSummary?.discussionSummary
                            ?.length > 156 ? (
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "left",
                                height: "100px",
                                alignItems: "center",
                              }}
                            >
                              {" "}
                              <div className="tooltipicon ">
                                {modalValue?.startupSummary?.discussionSummary.substring(
                                  0,
                                  156
                                )}
                                <svg
                                  style={{
                                    position: "relative",
                                    top: "0.1rem",
                                  }}
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="20"
                                  height="20"
                                  fill="currentColor"
                                  class="bi bi-three-dots"
                                  viewBox="0 0 16 16"
                                >
                                  <path d="M3 9.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z" />
                                </svg>
                                <span className="tooltiptext7">
                                  <h5 style={{ color: "#fff" }}>
                                    STARTUP SUMMARY
                                  </h5>
                                  {
                                    modalValue?.startupSummary
                                      ?.discussionSummary
                                  }
                                </span>
                              </div>
                            </div>
                          ) : (
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "left",
                                alignItems: "center",
                              }}
                            >
                              {modalValue?.startupSummary?.discussionSummary}
                            </div>
                          )}
                          {/* <p>{modalValue?.startupSummary === null ? "NA" : modalValue?.startupSummary?.discussionSummary}</p> */}
                        </td>
                      </tr>
                      <tr className="col-12">
                        <td className="session-question col-md-6 col-sm-6 col-11">
                          <p>MENTOR SUMMARY</p>
                        </td>
                        <td className="session-answer col-md-6 col-sm-6 col-1">
                          {modalValue?.mentorSummary?.discussionSummary
                            ?.length > 156 ? (
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "left",
                                height: "100px",
                                alignItems: "center",
                              }}
                            >
                              {" "}
                              <div className="tooltipicon ">
                                {modalValue?.mentorSummary?.discussionSummary.substring(
                                  0,
                                  156
                                )}
                                <svg
                                  style={{
                                    position: "relative",
                                    top: "0.1rem",
                                  }}
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="20"
                                  height="20"
                                  fill="currentColor"
                                  class="bi bi-three-dots"
                                  viewBox="0 0 16 16"
                                >
                                  <path d="M3 9.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z" />
                                </svg>
                                <span
                                  className="tooltiptext7"
                                  style={{ top: "-8rem" }}
                                >
                                  <h5 style={{ color: "#fff" }}>
                                    MENTOR SUMMARY
                                  </h5>
                                  {modalValue?.mentorSummary?.discussionSummary}
                                </span>
                              </div>
                            </div>
                          ) : (
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "left",
                                alignItems: "center",
                              }}
                            >
                              {modalValue?.mentorSummary?.discussionSummary}
                            </div>
                          )}
                          {/* <p>{modalValue?.mentorSummary === null ? "NA" : modalValue?.mentorSummary?.discussionSummary}</p> */}
                        </td>
                      </tr>
                      <tr className="col-12">
                        <td className="session-question col-md-6 col-sm-6 col-11">
                          <p>DOCUMENT BY STARTUP</p>
                        </td>
                        {modalValue?.startupSummary !== null &&
                        modalValue?.startupSummary?.uploadSupportingFile !==
                          null ? (
                          <td className="session-answer col-md-6 col-sm-6 col-1">
                            <div className="newuserTooltip">
                              <div className="modalButtonDoc viiwwdoc">
                                <a
                                  text="View Document"
                                  target="_blank"
                                  href={
                                    modalValue?.startupSummary
                                      ?.uploadSupportingFile
                                  }
                                >
                                  View Document
                                </a>
                              </div>
                              <span
                                className="tooltiptext tooltip-bottom"
                                style={{ top: "50px", left: "70px" }}
                              >
                                View Document
                              </span>
                            </div>
                          </td>
                        ) : (
                          <td className="col-md-6 col-sm-6 col-1 oterdocumentciew">
                            NA
                          </td>
                        )}
                      </tr>
                      <tr className="col-12">
                        <td className="session-question col-md-6 col-sm-6 col-11">
                          <p>DOCUMENT BY MENTOR</p>
                        </td>
                        {modalValue?.mentorSummary !== null &&
                        modalValue?.mentorSummary?.uploadSupportingFile !==
                          null ? (
                          <td className="session-answer col-md-6 col-sm-6 col-1">
                            <div className="newuserTooltip">
                              <div className="modalButtonDoc viiwwdoc">
                                <a
                                  text="View Document"
                                  target="_blank"
                                  href={
                                    modalValue?.mentorSummary
                                      ?.uploadSupportingFile
                                  }
                                >
                                  View Document
                                </a>
                              </div>
                              <span
                                className="tooltiptext tooltip-bottom"
                                style={{ top: "50px", left: "70px" }}
                              >
                                View Document
                              </span>
                            </div>
                          </td>
                        ) : (
                          <td className="fontpurposeText">NA</td>
                        )}
                      </tr>
                    </>

                    {/* )
            }
            */}
                  </tbody>
                </table>
                {/* */}
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer className="d-flex justify-content-center">
            <div className="d-flex summaryModalFooter">
              <div className="newuserTooltip top-btn">
                {/* <Button
            // onClick={handleFilterChanges}
            text="Load More"
            className="modalButton"
          >
            Save Changes
          </Button> */}
                <Button
                  onClick={handleClose}
                  text="CLOSE"
                  className="modalButton57 doc-upload"
                ></Button>
                <span
                  className="tooltiptext   tooltip-bottom"
                  style={{
                    top: "65px",
                    left: "50px",
                    width: "130px",
                    height: "25px",
                  }}
                >
                  Close window
                </span>
              </div>
              {/* <div>
                <Button
                  text="UPLOAD"
                  className="modalButton4"
                ></Button>
              </div> */}
            </div>
          </Modal.Footer>
        </Modal>
      </div>
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    getPredefineOptions: state.AdminMentorReducer.getPredefineOptionsList.list,
  };
};

export default connect(mapStateToProps, {})(withRouter(AllSummayModal));
